export interface Permission {
  read: boolean;
  write: boolean;
}

export enum PermissionAction {
  CREATE = 'Create',
  UPDATE = 'Update',
  DELETE = 'Delete',
}

export enum ResourcePolicy {
  SUBSCRIPTION = 'Subscription',
}

export enum PermissionAllow {
  EFFECT_ALLOW = 'EFFECT_ALLOW',
  EFFECT_DENY = 'EFFECT_DENY',
}
